import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    USER:{
      type:0,
      account:"",
      token:"",
    },
    TOKEN:""
  },
  mutations: {
    setUser(state,obj){
      state.USER = obj;
    },

    setToken(state,token){
      state.TOKEN = token;
    }
  }
})

export default  store


// WEBPACK FOOTER //
// ./src/store/index.js